import {
  restaurantReferralStatusColor,
  restaurantReferralStatusLabel,
} from '../../helpers/restaurantReferral';
import { Pill } from '../../styles/styles';
import { Disclaimer } from '../../styles/text';
import { lightTheme } from '../../styles/theme';
import { RestaurantReferralStatus } from '../../types/restaurantReferral.types';

type Props = {
  status: RestaurantReferralStatus;
};

/**
 * Where a restaurant referral stands - Signed up, Live, Earned, Expired - in
 * the same words and colour in the admin and merchant apps: white on a solid
 * fill, like every other admin status.
 */
export const RestaurantReferralStatusPill = ({ status }: Props) => (
  <Pill
    $background={restaurantReferralStatusColor(status)}
    style={{ flex: 'none' }}
  >
    <Disclaimer
      $m="0"
      $color={lightTheme.white}
      $semiBold
      $lineHeight="1"
      style={{ whiteSpace: 'nowrap' }}
    >
      {restaurantReferralStatusLabel(status)}
    </Disclaimer>
  </Pill>
);
